import React from 'react';
import Header from '../components/Header';
import FooterLinks from '../components/FooterLinks';
import PrivacyPolicySection from '../components/PrivacyPolicySection';

const heroStyles = {
  backgroundImage: "url('https://images.pexels.com/photos/5668882/pexels-photo-5668882.jpeg?auto=compress&cs=tinysrgb&w=1920')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-white text-gray-800">
    <Header />
    <div className="mt-32 sm:mt-36 lg:mt-32">

    <section className="relative w-full min-h-[50vh] sm:min-h-[55vh] lg:min-h-[60vh]" style={heroStyles}>
      <div className="absolute inset-0 bg-black/40" />
    </section>

    <PrivacyPolicySection />

    <section className="py-12 px-8" style={{ backgroundColor: '#f5f5f5' }}>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8">
          <div className="md:w-5/12 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-medium text-gray-900">
              Have questions about your data?
            </h2>
          </div>
          <div className="md:w-4/12">
            <a
              href="mailto:Info@testacare.co.uk"
              className="block text-center px-8 py-3 text-white text-base font-medium hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2f4c74' }}
            >
              Email us
            </a>
          </div>
        </div>
      </div>
    </section>

    <FooterLinks />
    </div>
  </div>
);

export default PrivacyPolicy;


